/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-02-03 12:00:00
 *
 *******************************************************/
//flow
import _ from 'lodash';
import React, { Component } from 'react';
import { Stack, RadioButton } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { getFeedbackOptions } from 'src/constants/theme-setup';

type Props = {
  value: number,
  handleChangeValueOption: (checked: boolean, newValue: number) => void,
  removeFeatures: string[]
};

type ComposedProps = Props & WithI18nProps;

class Options extends Component<ComposedProps> {
  render() {
    const { i18n, handleChangeValueOption, value, removeFeatures } = this.props;
    const feature = !_.isEmpty(removeFeatures) && removeFeatures.length === 1 ? removeFeatures[0] : '';
    const optionList = getFeedbackOptions(i18n, feature);

    return (
      <div>
        <Stack vertical>
          {_.map(optionList, (option, index) => (
            <RadioButton
              label={option.label}
              checked={value === option.id}
              id={option.id.toString()}
              name="options"
              onChange={handleChangeValueOption}
              key={index}
            />
          ))}
        </Stack>
      </div>
    );
  }
}

export default withI18n()(Options);
